import { createSlice } from "@reduxjs/toolkit";

const orderslice = createSlice({
  name: "order",
  initialState: {
    getpendingorderloading: false,
    getpendingorder: null,
    getpendingordererror: null,

    getprocessingorderloading: false,
    getprocessingorder: null,
    getprocessingordererror: null,

    getshippedorderloading: false,
    getshippedorder: null,
    getshippedordererror: null,

    getdeliveredorderloading: false,
    getdeliveredorder: null,
    getdeliveredordererror: null,

    getallorderloading: false,
    allorderdata: null,
    getallordererror: null,

    //  get all order user page
    getallorderloading: false,
    allorderdata: null,
    getallordererror: null,


    updateorderstatusloading: false,
    updateorderstatus: null,
    updateorderstatuserror: null,
  },
  reducers: {
    getpendingorderRequest: (state) => {
      state.getpendingorderloading = true;
      state.getpendingorder = null;
      state.getpendingordererror = null;
    },
    getpendingorderSuccess: (state, action) => {
      state.getpendingorderloading = false;
      state.getpendingorder = action.payload;
    },
    getpendingorderFailure: (state, action) => {
      state.getpendingorderloading = false;
      state.getpendingordererror = action.payload;
    },

    getprocessingorderRequest: (state) => {
      state.getprocessingorderloading = true;
      state.getprocessingorder = null;
      state.getprocessingordererror = null;
    },
    getprocessingorderSuccess: (state, action) => {
      state.getprocessingorderloading = false;
      state.getprocessingorder = action.payload;
    },
    getprocessingorderFailure: (state, action) => {
      state.getprocessingorderloading = false;
      state.getprocessingordererror = action.payload;
    },

    getshippedorderRequest: (state) => {
      state.getshippedorderloading = true;
      state.getshippedorder = null;
      state.getshippedordererror = null;
    },
    getshippedorderSuccess: (state, action) => {
      state.getshippedorderloading = false;
      state.getshippedorder = action.payload;
    },
    getshippedorderFailure: (state, action) => {
      state.getshippedorderloading = false;
      state.getshippedordererror = action.payload;
    },

    getdeliveredorderRequest: (state) => {
      state.getdeliveredorderloading = true;
      state.getdeliveredorder = null;
      state.getdeliveredordererror = null;
    },
    getdeliveredorderSuccess: (state, action) => {
      state.getdeliveredorderloading = false;
      state.getdeliveredorder = action.payload;
    },
    getdeliveredorderFailure: (state, action) => {
      state.getdeliveredorderloading = false;
      state.getdeliveredordererror = action.payload;
    },

    getallorderRequest: (state) => {
      state.getallorderloading = true;
      state.allorderdata = null;
      state.getallordererror = null;
    },
    getallorderSuccess: (state, action) => {
      state.getallorderloading = false;
      state.allorderdata = action.payload;
    },
    getallorderFailure: (state, action) => {
      state.getallorderloading = false;
      state.getallordererror = action.payload;
    },
    updateorderstatusRequest: (state) => {
      state.updateorderstatusloading = true;
      state.updateorderstatus = null;
      state.updateorderstatuserror = null;
    },
    updateorderstatusSuccess: (state, action) => {
      state.updateorderstatusloading = false;
      state.updateorderstatus = action.payload;
    },
    updateorderstatusFailure: (state, action) => {
      state.updateorderstatusloading = false;
      state.updateorderstatuserror = action.payload;
    },
  },
});

export const {
  getpendingorderRequest,
  getpendingorderSuccess,
  getpendingorderFailure,
  getprocessingorderRequest,
  getprocessingorderSuccess,
  getprocessingorderFailure,
  getshippedorderRequest,
  getshippedorderSuccess,
  getshippedorderFailure,
  getdeliveredorderRequest,
  getdeliveredorderSuccess,
  getdeliveredorderFailure,
  getallorderRequest,
  getallorderSuccess,
  getallorderFailure,
  updateorderstatusRequest,
  updateorderstatusSuccess,
  updateorderstatusFailure,
} = orderslice.actions;

export default orderslice.reducer;
